import { createResourceRegistry } from './resource-registry.js';
/**
 * @internal
 */
export const registry = createResourceRegistry(false);
/**
 * Register a Micro Front-End into the global record.
 * @public
 * @remarks It will fail if the same Micro Front-End is register twice.
 * @param mfe - Micro Front-End information
 */
export function registerMFE(mfe) {
    registry.add(mfe);
}
/**
 * Retrieves all the registered Micro Front-Ends.
 * @public
 * @returns Map with all registered Micro Front-Ends
 */
export function getMFEs() {
    return registry.list();
}
/**
 * Retrieves a single registered Micro Front-End based on the name of it.
 * @public
 * @param name - Name of the Micro Front-End
 * @returns Registered Micro Front-End or undefined if the Micro Front-End is not registered
 */
export function getMFE(name) {
    return registry.get(name);
}
/**
 * Removes a Micro Front-End from the registry
 * @internal
 * @remarks Should not be exported to the public
 * @param name - Name of the Micro Front-End to remove
 */
export function removeMFE(name) {
    registry.remove(name);
}
